module.exports = __webpack_public_path__ + "static/media/amico.459362d6.svg";